/* Behaviour of the Impulse header, nav drawer, collapsibles, announcement slider and
   predictive search, rewritten without Impulse's theme.js / vendor bundle. Cart = Dawn cart-drawer. */
(() => {
  const root = document.documentElement;
  const bpSmall = () => matchMedia('(max-width: 768px)').matches;
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  function prepareTransition(el, cb) {
    const done = () => { el.classList.remove('is-transitioning'); el.removeEventListener('transitionend', done); };
    el.addEventListener('transitionend', done);
    el.classList.add('is-transitioning');
    el.offsetWidth;
    cb && cb();
  }
  const lockScroll = () => root.classList.add('lock-scroll');
  const unlockScroll = () => root.classList.remove('lock-scroll');

  /* ---------- drawers (Impulse theme.Drawers): nav drawer, collection filter drawer ---------- */
  function Drawer(id, name) {
    const drawer = document.getElementById(id);
    if (!drawer) return null;
    let isOpen = false, source = null;
    const onClick = (e) => { if (!e.target.closest('.js-drawer-close') && e.target.closest('.drawer')) return; close(); };
    const onKey = (e) => { if (e.keyCode === 27) close(); };
    function open(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); source = e.currentTarget; source.setAttribute('aria-expanded', 'true'); }
      if (isOpen) return;
      prepareTransition(drawer, () => drawer.classList.add('drawer--is-open'));
      root.classList.add('js-drawer-open');
      isOpen = true;
      window.addEventListener('click', onClick);
      window.addEventListener('keyup', onKey);
      lockScroll();
    }
    function close(e) {
      if (!isOpen) return;
      document.activeElement && document.activeElement.blur();
      prepareTransition(drawer, () => drawer.classList.remove('drawer--is-open'));
      root.classList.remove('js-drawer-open');
      root.classList.add('js-drawer-closing');
      setTimeout(() => {
        root.classList.remove('js-drawer-closing');
        if (source) { source.setAttribute('aria-expanded', 'false'); source.focus(); }
      }, 500);
      isOpen = false;
      window.removeEventListener('click', onClick);
      window.removeEventListener('keyup', onKey);
      unlockScroll();
    }
    document.querySelectorAll('.js-drawer-open-' + name).forEach((b) => { b.setAttribute('aria-expanded', 'false'); b.addEventListener('click', open); });
    drawer.querySelectorAll('.js-drawer-close').forEach((b) => b.addEventListener('click', close));
    return { open, close };
  }
  function navDrawer() { Drawer('NavDrawer', 'nav'); }

  /* ---------- collapsibles (Impulse theme.collapsibles) ---------- */
  let transitioning = false;
  function setHeight(c, h, isOpen, auto) {
    c.classList.remove('hide');
    prepareTransition(c, () => { c.style.height = h + 'px'; c.classList.toggle('is-open', !isOpen); });
    if (!isOpen && auto) setTimeout(() => { c.style.height = 'auto'; transitioning = false; }, 500);
    else transitioning = false;
  }
  function toggle(e) {
    if (transitioning) return;
    transitioning = true;
    const el = e.currentTarget;
    const isOpen = el.classList.contains('is-open');
    const isTab = el.classList.contains('collapsible-trigger--tab');
    const id = el.getAttribute('aria-controls') || el.dataset.controls;
    let c = id && document.getElementById(id);
    if (!c && id) c = el.parentNode.querySelector('[data-id="' + id + '"]');
    if (!c) { transitioning = false; return; }
    let h = c.querySelector('.collapsible-content__inner').offsetHeight;
    const auto = c.classList.contains('collapsible--auto-height');
    const parent = c.parentNode.closest('.collapsible-content');
    const childH = h;
    if (isTab) {
      if (isOpen) { transitioning = false; return; }
      document.querySelectorAll('.collapsible-trigger--tab[data-id="' + el.dataset.id + '"]').forEach((t) => {
        t.classList.remove('is-open');
        setHeight(document.getElementById(t.getAttribute('aria-controls')), 0, true);
      });
    }
    if (isOpen && auto) setTimeout(() => setHeight(c, 0, isOpen, auto), 0);
    if (isOpen && !auto) h = 0;
    el.setAttribute('aria-expanded', !isOpen);
    el.classList.toggle('is-open', !isOpen);
    setHeight(c, h, isOpen, auto);
    if (parent) setHeight(parent, isOpen ? parent.offsetHeight - childH : h + parent.offsetHeight, false, false);
  }
  function collapsibles(scope) {
    (scope || document).querySelectorAll('.tc-impulse .collapsible-trigger').forEach((t) => {
      if (t.dataset.tcBound) return;
      t.dataset.tcBound = '1';
      t.setAttribute('aria-expanded', t.classList.contains('is-open'));
      t.addEventListener('click', toggle);
    });
  }

  /* ---------- header: sticky, dropdowns, search (Impulse theme.headerNav) ---------- */
  function header() {
    const wrapper = document.getElementById('HeaderWrapper');
    const siteHeader = document.getElementById('SiteHeader');
    if (!siteHeader) return;
    let lastScroll = 0;

    if (siteHeader.dataset.sticky === 'true') {
      let biggest = 0;
      siteHeader.querySelectorAll('.megamenu').forEach((n) => { biggest = Math.max(biggest, n.offsetHeight); });
      if (window.innerHeight >= biggest + 120) {
        const wrap = document.createElement('div');
        wrap.id = 'StickyHeaderWrap';
        siteHeader.parentNode.insertBefore(wrap, siteHeader);
        wrap.appendChild(siteHeader);
        const setH = () => { wrap.style.height = siteHeader.offsetHeight + 'px'; };
        setH();
        let t;
        window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(setH, 50); });
        let active = false, ticking = 0;
        const handler = () => {
          if (window.scrollY > 250) {
            if (active) return;
            active = true;
            siteHeader.classList.add('site-header--stuck');
            setTimeout(() => siteHeader.classList.add('site-header--opening'), 100);
          } else if (active) {
            active = false;
            siteHeader.classList.remove('site-header--opening', 'site-header--stuck');
          }
        };
        window.addEventListener('scroll', () => {
          const now = Date.now();
          if (now - ticking < 20) return;
          ticking = now;
          requestAnimationFrame(handler);
          lastScroll = window.scrollY;
        }, { passive: true });
      }
    }

    // dropdowns
    let closeOnClick = false;
    const navItems = siteHeader.querySelectorAll('.site-nav__item');
    const closeAll = () => {
      navItems.forEach((el) => el.classList.remove('is-focused'));
      siteHeader.querySelectorAll('.site-nav__dropdown-link--second-level').forEach((el) => el.parentNode.classList.remove('is-focused'));
    };
    const openFirst = (link) => {
      const p = link.parentNode;
      if (p.classList.contains('site-nav--has-dropdown')) p.classList.add('is-focused');
      if (!isTouch && !closeOnClick) {
        closeOnClick = true;
        const h = () => { closeAll(); root.removeEventListener('click', h); closeOnClick = false; };
        root.addEventListener('click', h);
      }
    };
    if (isTouch) {
      siteHeader.querySelectorAll('.site-nav__link--has-dropdown').forEach((el) => el.addEventListener('touchend', (e) => {
        if (!e.currentTarget.parentNode.classList.contains('is-focused')) { e.preventDefault(); closeAll(); openFirst(e.currentTarget); }
        else window.location.replace(e.currentTarget.getAttribute('href'));
      }));
      document.body.addEventListener('touchend', closeAll);
      siteHeader.querySelectorAll('.megamenu').forEach((el) => el.addEventListener('touchend', (e) => e.stopImmediatePropagation()));
    }
    siteHeader.querySelectorAll('.site-nav__link').forEach((el) => {
      const ev = (e) => { closeAll(); openFirst(e.currentTarget); };
      el.addEventListener('focusin', ev);
      el.addEventListener('mouseover', ev);
      el.addEventListener('mouseleave', closeAll);
    });

    // search drawer
    const container = siteHeader.querySelector('.site-header__search-container');
    const onKey = (e) => { if (e.keyCode === 27) closeSearch(); };
    const onDocClick = (e) => closeSearch(e);
    function openSearch(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      prepareTransition(container, () => container.classList.add('is-active'));
      root.classList.add('js-drawer-open', 'js-drawer-open--search');
      setTimeout(() => { const i = container.querySelector('.site-header__search-input'); i && i.focus(); }, 100);
      if (bpSmall() && siteHeader.dataset.sticky === 'true' && lastScroll < 300) window.scrollTo(0, 0);
      lockScroll();
      window.addEventListener('keyup', onKey);
      root.addEventListener('click', onDocClick);
    }
    function closeSearch(e) {
      if (e) {
        const path = e.composedPath ? e.composedPath() : [];
        for (const n of path) {
          if (!n.classList) continue;
          if (n.classList.contains('site-header__search-btn')) break;
          if (n.classList.contains('site-header__search-container')) return;
        }
      }
      document.activeElement && document.activeElement.blur();
      root.classList.add('js-drawer-closing');
      root.classList.remove('js-drawer-open', 'js-drawer-open--search');
      setTimeout(() => root.classList.remove('js-drawer-closing'), 500);
      prepareTransition(container, () => container.classList.remove('is-active'));
      unlockScroll();
      window.removeEventListener('keyup', onKey);
      root.removeEventListener('click', onDocClick);
    }
    document.querySelectorAll('.js-search-header').forEach((b) => b.addEventListener('click', openSearch));
    const sc = document.getElementById('SearchClose');
    sc && sc.addEventListener('click', closeSearch);
    predictive();
  }

  /* ---------- predictive search (Impulse theme.predictiveSearch, product grid markup) ---------- */
  function predictive() {
    const wrapper = document.getElementById('PredictiveWrapper');
    if (!wrapper) return;
    const form = document.getElementById('HeaderSearchForm');
    const input = form.querySelector('input[type="search"]');
    const results = document.getElementById('PredictiveResults');
    const S = window.tcStrings || {};
    let current = '', loading = false, timer;
    form.setAttribute('autocomplete', 'off');
    const param = (o) => Object.keys(o).map((k) => k + '=' + encodeURIComponent(o[k])).join('&');
    const reset = () => { wrapper.classList.add('hide'); results.innerHTML = ''; clearTimeout(timer); };
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const o = {};
      for (const [k, v] of new FormData(form)) o[k] = v;
      if (o.q) o.q += '*';
      window.location.href = '/search?' + param(o);
    });
    wrapper.querySelector('[data-predictive-search-button]').addEventListener('click', () => form.submit());
    const sized = (src, w) => src.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2');
    const img = (p) => {
      if (!p.image) return '';
      const set = [180, 360, 540, 720, 900].map((w) => sized(p.image, w) + ' ' + w + 'w').join(', ');
      return `<div class="grid__image-ratio grid__image-ratio--${wrapper.dataset.imageSize}">
        <img class="lazyload" src="${sized(p.image, 360)}" srcset="${set}" sizes="auto" alt="${p.title}" loading="lazy"></div>`;
    };
    const list = (type, label, items) => items.length ? `<div data-type-${type}><p class="h6 predictive__label">${label}</p><ul class="no-bullets">${items.map((i) => `<li><a href="${i.url}">${i.title}</a></li>`).join('')}</ul></div>` : '';
    function query(q) {
      if (loading || current === q) return;
      current = q;
      loading = true;
      fetch('/search/suggest.json?' + param({
        q, 'resources[type]': S.searchType || 'product,article,page,collection', 'resources[limit]': 4,
        'resources[options][unavailable_products]': 'last', 'resources[options][fields]': 'title,product_type,variants.title,vendor'
      })).then((r) => r.json()).then((d) => {
        loading = false;
        wrapper.classList.remove('hide');
        const r = d.resources.results;
        const n = Object.values(r).reduce((a, x) => a + x.length, 0);
        if (!n) { reset(); return; }
        let out = '';
        if (r.products && r.products.length) {
          out += `<div data-type-products><div class="grid grid--uniform">${r.products.map((p) => `
            <div class="grid__item grid-product small--one-half medium-up--one-quarter aos-animate" data-aos="row-of-4">
              <div class="grid-product__content"><a href="${p.url}" class="grid-product__link">
                <div class="grid-product__image-mask">${img(p)}</div>
                <div class="grid-product__meta"><div class="grid-product__title">${p.title}</div></div>
              </a></div></div>`).join('')}</div></div>`;
        }
        out += list('collections', S.searchCollections || 'Collections', r.collections || []);
        out += list('pages', S.searchPages || 'Pages', r.pages || []);
        if (r.articles && r.articles.length) out += list('articles', S.searchArticles || 'Articles', r.articles);
        results.innerHTML = out;
      });
    }
    input.addEventListener('keyup', (e) => {
      if ([38, 40, 9].includes(e.keyCode)) return;
      const v = input.value;
      if (v === '') { reset(); return; }
      const q = v.trim().replace(/ /g, '-').toLowerCase();
      clearTimeout(timer);
      timer = setTimeout(() => query(q), 500);
    });
  }

  /* ---------- announcement slider (Flickity: autoplay 5s, wrap-around, drag) ---------- */
  function announcement() {
    const bar = document.getElementById('AnnouncementSlider');
    if (!bar) return;
    const slides = [...bar.querySelectorAll('.announcement-slider__slide')];
    if (slides.length < 2) return;
    let track, idx = 0, timer, paused = false, enabled = false;
    function enable() {
      if (enabled) return;
      enabled = true;
      bar.classList.add('flickity-enabled');
      track = document.createElement('div');
      track.className = 'tc-ann-track';
      slides.forEach((s) => track.appendChild(s));
      const vp = document.createElement('div');
      vp.className = 'flickity-viewport';
      vp.appendChild(track);
      bar.appendChild(vp);
      // Flickity setGallerySize: inline height from the computed slide height string (4 decimals), which Chrome
      // floors to 1/64 px. Letting the viewport size itself leaves everything below up to 1/64 px lower than Impulse.
      const size = () => { vp.style.height = Math.max(...slides.map((s) => parseFloat(getComputedStyle(s).height) || 0)) + 'px'; };
      size();
      // measured before the web font is in, a long slide can wrap one line too many at 360 px: measure again
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
      window.addEventListener('load', size);
      let rt;
      window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(size, 150); });
      go(0, false);
      play();
      let x0 = null, dx = 0;
      vp.addEventListener('pointerdown', (e) => { x0 = e.clientX; dx = 0; stop(); });
      window.addEventListener('pointermove', (e) => { if (x0 === null) return; dx = e.clientX - x0; track.style.transition = 'none'; track.style.transform = `translateX(calc(${-idx * 100}% + ${dx}px))`; });
      window.addEventListener('pointerup', () => {
        if (x0 === null) return;
        x0 = null;
        go(Math.abs(dx) > 7 ? idx + (dx < 0 ? 1 : -1) : idx, true);
        if (!paused) play();
      });
    }
    function go(i, anim) {
      idx = (i + slides.length) % slides.length;
      track.style.transition = anim ? 'transform .6s cubic-bezier(.25,.8,.25,1)' : 'none';
      track.style.transform = `translateX(${-idx * 100}%)`;
      slides.forEach((s, n) => s.classList.toggle('is-selected', n === idx));
    }
    function play() { stop(); timer = setInterval(() => go(idx + 1, true), 5000); }
    function stop() { clearInterval(timer); }
    if (bpSmall() || bar.dataset.compact === 'true') enable();
    matchMedia('(max-width: 768px)').addEventListener('change', (m) => { if (m.matches) enable(); });
    const pause = bar.closest('.slideshow-wrapper') && bar.closest('.slideshow-wrapper').querySelector('.slideshow__pause');
    pause && pause.addEventListener('click', () => {
      paused = !paused;
      pause.closest('.slideshow-wrapper').classList.toggle('is-paused', paused);
      paused ? stop() : play();
    });
  }

  /* ---------- Dawn cart-drawer -> Impulse drawer classes (slide, page scrim), header count ---------- */
  function cartDrawer() {
    const cd = document.querySelector('cart-drawer');
    const panel = document.getElementById('CartDrawer');
    if (!cd || !panel) return;
    let open = false;
    new MutationObserver(() => {
      const on = cd.classList.contains('active');
      if (on === open) return;
      open = on;
      if (on) {
        prepareTransition(panel, () => panel.classList.add('drawer--is-open'));
        root.classList.add('js-drawer-open', 'lock-scroll');
      } else {
        prepareTransition(panel, () => panel.classList.remove('drawer--is-open'));
        root.classList.remove('js-drawer-open', 'lock-scroll');
        root.classList.add('js-drawer-closing');
        setTimeout(() => root.classList.remove('js-drawer-closing'), 500);
      }
    }).observe(cd, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('keyup', (e) => { if (e.code === 'Escape' && open) cd.close(); });
    /* Dawn's +/- fires a bubbling change event that Impulse never fired; Google's form tracking read it as form_start. */
    document.querySelectorAll('cart-drawer, #main-cart-items').forEach((el) => el.addEventListener('change', (e) => {
      if (e.target.matches('.js-qty__num')) e.stopPropagation();
    }));
    if (/[?&]cart=open(&|$)/.test(location.search)) window.addEventListener('load', () => cd.open());
  }

  document.addEventListener('keyup', function tab(e) {
    if (e.keyCode === 9) { root.classList.add('tab-outline'); document.removeEventListener('keyup', tab); }
  });

  /* ---------- AOS (once, offset 60): adds .aos-animate when an element scrolls into view ---------- */
  let aosObserver;
  function aos(scope) {
    if (!aosObserver) {
      aosObserver = new IntersectionObserver((entries) => entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('aos-animate');
        aosObserver.unobserve(e.target);
      }), { rootMargin: '0px 0px -60px 0px' });
    }
    (scope || document).querySelectorAll('[data-aos]:not(.aos-init)').forEach((el) => {
      el.classList.add('aos-init');
      aosObserver.observe(el);
    });
  }

  const whenVisible = (el, margin, cb) => {
    const io = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { io.disconnect(); cb(); } }, { rootMargin: margin + 'px 0px' });
    io.observe(el);
  };

  /* ---------- product recommendations (Impulse theme.Recommendations) ---------- */
  function recommendations() {
    document.querySelectorAll('[data-section-type="product-recommendations"]').forEach((section) => {
      if (section.dataset.enable === 'false') return;
      whenVisible(section, 500, () => {
        const url = `${section.dataset.url}?section_id=imp-product-recommendations&limit=${section.dataset.limit}&product_id=${section.dataset.productId}`;
        fetch(url).then((r) => r.text()).then((html) => {
          const div = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-recommendations');
          const ph = section.querySelector('.product-recommendations-placeholder');
          if (!ph) return;
          ph.innerHTML = '';
          if (!div || !div.querySelector('.grid-product')) { section.classList.add('hide'); return; }
          ph.appendChild(div);
          aos(section);
        });
      });
    });
  }

  /* ---------- recently viewed (Impulse: localStorage 'theme-recent', image + title cards) ---------- */
  function recentlyViewed() {
    let recent = {};
    try { recent = JSON.parse(localStorage.getItem('theme-recent') || '{}') || {}; } catch (e) {}
    const prod = document.querySelector('product-info[data-product-handle]');
    if (prod) {
      const h = prod.dataset.productHandle;
      delete recent[h];
      recent[h] = { url: prod.dataset.productUrl, aspectRatio: prod.dataset.aspectRatio, featuredImage: prod.dataset.imgUrl };
      try { localStorage.setItem('theme-recent', JSON.stringify(recent)); } catch (e) {}
    }
    const c = document.querySelector('[data-section-type="recently-viewed"]');
    if (!c) return;
    if (!Object.keys(recent).length) { c.classList.add('hide'); return; }
    whenVisible(c, 600, () => {
      const out = document.getElementById('RecentlyViewed-' + c.dataset.sectionId);
      const handle = c.dataset.productHandle;
      let info = {};
      try { info = JSON.parse(sessionStorage['recent-products'] || '{}'); } catch (e) {}
      const get = (h) => info[h] ? Promise.resolve(info[h]) : fetch('/products/' + h + '.js').then((r) => r.text());
      const hs = Object.keys(recent).filter((h) => h !== 'undefined');
      Promise.all(hs.map(get)).then((res) => {
        const items = [];
        res.forEach((txt, i) => {
          let p; try { p = JSON.parse(txt); } catch (e) { return; }
          info[hs[i]] = txt;
          if (!p.handle || p.handle === handle) return;
          const r = recent[p.handle] || {};
          items.unshift({ url: r.url || p.url, title: p.title, img: r.featuredImage || '', ratio: r.aspectRatio });
        });
        try { sessionStorage.setItem('recent-products', JSON.stringify(info)); } catch (e) {}
        if (!items.length) { c.classList.add('hide'); return; }
        const size = window.tcStrings && window.tcStrings.productImageSize || 'portrait';
        const cover = !(window.tcStrings && window.tcStrings.productImageCover === false);
        out.innerHTML = items.slice(0, +c.dataset.recentCount).map((p) => {
          const set = p.img ? [360, 540, 720, 900, 1080].map((w) => p.img.replace('{width}', w) + ' ' + w + 'w').join(', ') : '';
          return `<div class="grid__item grid-product ${c.dataset.gridItemClass} aos-animate" data-aos="row-of-${c.dataset.rowOf}">
            <div class="grid-product__content"><a href="${p.url}" class="grid-product__link"><div class="grid-product__image-mask">
              <div class="grid__image-ratio grid__image-ratio--${size}"><img class="lazyload${cover ? '' : ' grid__image-contain'}" src="${p.img.replace('{width}', 540)}" srcset="${set}" sizes="auto" loading="lazy" alt="${p.title.replace(/"/g, '&quot;')}"></div>
            </div><div class="grid-product__meta"><div class="grid-product__title">${p.title}</div></div></a></div></div>`;
        }).join('');
        aos(c);
      });
    });
  }

  /* ---------- lazysizes parity: images get .lazyloaded (which starts Impulse's fade-in) once loaded ---------- */
  function markLoaded(img) {
    if (img.classList.contains('lazyloaded')) return;
    const done = () => { img.classList.remove('lazyload'); img.classList.add('lazyloaded'); fileRatio(img); };
    if (img.complete && img.naturalWidth) done();
    else img.addEventListener('load', done, { once: true });
  }
  // Impulse images are height:auto, so they take the shape of the file that was downloaded (the CDN rounds the height,
  // e.g. 900×507 for a 1.7768 original). Chrome ignores a sizes="auto" image's own shape, so after load read the
  // file's real size (memory-cached) and pin that ratio, otherwise the box stays up to 0.2 px off.
  function fileRatio(img) {
    if (!/aspect-ratio/.test(img.getAttribute('style') || '') || !img.currentSrc) return;
    const probe = new Image();
    probe.onload = () => { if (probe.naturalWidth && probe.naturalHeight) img.style.aspectRatio = `${probe.naturalWidth} / ${probe.naturalHeight}`; };
    probe.src = img.currentSrc;
  }
  function lazyImages(scope) { (scope || document).querySelectorAll('img.lazyload').forEach(markLoaded); }
  lazyImages();
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => {
    if (n.nodeType !== 1) return;
    if (n.matches('img.lazyload')) markLoaded(n); else lazyImages(n);
  }))).observe(document.documentElement, { childList: true, subtree: true });

  window.tcImpulse = { collapsibles, prepareTransition, aos, Drawer };
  const init = () => { navDrawer(); collapsibles(); header(); announcement(); cartDrawer(); aos(); recommendations(); recentlyViewed(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
